<template>
	<div class="kucun">
        <main>
            <span>油罐： </span>
            <el-select v-model="address" placeholder="请选择加油油罐" >
                <el-option
                    v-for="(item,i) in options"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>

            <span style="margin-left:30px">起止日期： </span>
            <el-date-picker
                v-model="time_search"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>
        </main>

        <el-card>
            <div style="padding-bottom:60vh">
                <el-button type="primary" @click="buy()" style="margin-left:20px">油量购入</el-button>
                <el-button type="primary" @click="search1()" style="margin-left:20px">购入记录查询</el-button>
                <el-button type="success" @click="chaYi()" style="margin-left:20px">油耗差异填写</el-button>
                <el-button type="success" @click="search2()" style="margin-left:20px">油耗差异查询</el-button>
                <el-button type="warning" @click="searchSy()" style="margin-left:20px">使用记录查询</el-button>
                <el-button type="warning" @click="search3()" style="margin-left:20px">实时库存查询</el-button>
            </div>
        </el-card>

        <el-dialog
            title="购入油量"
            :visible.sync="dialogVisible"
            width="500px">
            <el-card>
                <span style="margin-right:30px">购入油罐 </span>
                <el-input v-model="address" placeholder="请输入内容" style="width:300px" :disabled='true'></el-input>
                <br/>
                <br/>
                <span style="margin-right:30px">购入升数 </span>
                <el-input v-model="shengshu" placeholder="请输入内容" style="width:300px" type="number"></el-input>
                <br/>
                <br/>
                <span style="margin-right:30px">购入金额 </span>
                <el-input v-model="money" placeholder="请输入内容" type="number" style="width:300px"></el-input>
                <br/>
                <br/>
                <span style="margin-right:32px">购入时间</span>
                <el-date-picker
                    style="width:300px"
                    v-model="time"
                    type="datetime"
                    placeholder="选择日期时间">
                </el-date-picker>
                <br/>
                <br/>
                <span style="margin-right:56px">备注</span>
                <el-input v-model="mess" placeholder="请输入内容" style="width:300px"></el-input>
                <br/>
                <br/>
                <el-button type="primary" @click="sure()" style="width:100%">确定</el-button>
            </el-card>
        </el-dialog>

        <el-dialog
            title="使用记录"
            :visible.sync="dialogVisible2"
            width="400px">
            <el-card>
                <p>车辆用油使用{{kucun1}}升</p>
                <p>生产领用使用{{kucun2}}升</p>
                <p>其他用油使用{{kucun3}}升</p>
                <p>共使用{{(kucun1+kucun2+kucun3).toFixed(2)}}升</p>
            </el-card>
        </el-dialog>

        <el-dialog
            width="80%"
            title="购入油量"
            style="margin-top:-10vh"
            :visible.sync="dialogVisible3">
            <el-card style="border: solid #ccc 1px">
                <p><span style="margin-right: 20px;">购入{{kucun_buy}}升</span> <span>购入{{kucun_all_money}}元</span></p>
                
                <el-table
                    :data="tableData"
                    stripe
                    border
                    height="50vh"
                    style="width: 200%">
                    <el-table-column
                        prop="address"
                        label="油罐">
                    </el-table-column>

                    <el-table-column
                        prop="create_time"
                        label="提交时间">
                    </el-table-column>

                    <el-table-column
                        prop="shengshu"
                        label="购入升数">
                    </el-table-column>

                    <el-table-column
                        prop="money"
                        label="购入金额">
                    </el-table-column>

                    <el-table-column
                        prop="time"
                        label="购入时间">
                    </el-table-column>

                    <el-table-column
                        prop="name"
                        label="提交人">
                    </el-table-column>

                    <el-table-column
                        prop="mess"
                        label="备注">
                    </el-table-column>

                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status==0">待审核</p>
                            <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                            <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                        </template>
                    </el-table-column>

                    <el-table-column label="审核" width="180">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status!=1">
                                <el-button type="text" @click="caoZuoKucun(scope.row.id,1)">通过</el-button>
                                <el-button type="text" style="color:#F56C6C" @click="caoZuoKucun(scope.row.id,2)">拒绝</el-button>
                                <el-button type="text" style="color:#909399" @click="caoZuoKucun(scope.row.id,3)">删除</el-button>
                            </div> 
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="shenpiren"
                        label="审批人">
                    </el-table-column>

                </el-table>

                <el-pagination
                    style="margin:20px 0"
                    background
                    @current-change="handleCurrentChange"
                    :current-page="current_page"
                    :page-size="per_page"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </el-card>
        </el-dialog>

        <el-dialog
            title="实时库存"
            :visible.sync="dialogVisible4"
            width="600px">
            <el-card>
                <p>初始油量{{start}}升</p>
                <el-divider></el-divider>
                <p>累计购入{{kucun_buy}}升</p>
                <el-divider></el-divider>
                <p>车辆用油{{kucun1}}升</p>
                <p>生产领用{{kucun2}}升</p>
                <p>其他用油{{kucun3}}升</p>
                <p>共使用{{(kucun1+kucun2+kucun3).toFixed(2)}}升</p>
                <el-divider></el-divider>
                <p>油耗差异{{kucun_chayi}}升</p>
                <el-divider></el-divider>
                <p>当前油量{{now}}升</p>
            </el-card>
        </el-dialog>  

        <el-dialog
            title="油耗差异"
            :visible.sync="dialogVisible5"
            width="500px">
            <el-card>
                <span>差异油罐 </span>
                <el-input v-model="address" placeholder="请输入内容" style="margin-left:22px;width:300px" :disabled='true'></el-input>
                <br/>
                <br/>
                <span>差异日期 </span>
                <el-date-picker
                    style="margin-left:22px;width:300px"
                    v-model="time2"
                    type="datetime"
                    placeholder="选择日期时间">
                </el-date-picker>
                <br/>
                <br/>
                <span>差异数 </span>
                <el-input v-model="chayi" type="number" placeholder="请输入内容" style="margin-left:34px;width:300px"></el-input>
                <br/>
                <br/>
                <span>备注 </span>
                <el-input v-model="mess2" placeholder="请输入内容" style="margin-left:46px;width:300px"></el-input>
                <br/>
                <br/>
                <br/>
                <el-button type="primary" @click="cySure()" style="width:100%">确定</el-button>
            </el-card>
        </el-dialog>  

        <el-dialog
            width="80%"
            title="油耗差异"
            style="margin-top:-10vh"
            :visible.sync="dialogVisible6">
            <el-card style="border: solid #ccc 1px">
                <p>差异{{kucun_chayi}}升</p>
                <el-table
                    :data="tableData2"
                    stripe
                    border
                    height="50vh"
                    style="width: 200%">
                    <el-table-column
                        prop="address"
                        label="油罐">
                    </el-table-column>

                    <el-table-column
                        prop="create_time"
                        label="提交时间">
                    </el-table-column>

                    <el-table-column
                        prop="time"
                        label="填写时间">
                    </el-table-column>

                    <el-table-column
                        prop="chayi"
                        label="差异升数">
                    </el-table-column>

                    <el-table-column
                        prop="name"
                        label="提交人">
                    </el-table-column>

                    <el-table-column
                        prop="mess"
                        label="备注">
                    </el-table-column>

                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status==0">待审核</p>
                            <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                            <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                        </template>
                    </el-table-column>

                    <el-table-column label="审核" width="180">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status!=1">
                                <el-button type="text" @click="caoZuoKucun2(scope.row.id,1)">通过</el-button>
                                <el-button type="text" style="color:#F56C6C" @click="caoZuoKucun2(scope.row.id,2)">拒绝</el-button>
                                <el-button type="text" style="color:#909399" @click="caoZuoKucun2(scope.row.id,3)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="shenpiren"
                        label="审批人">
                    </el-table-column>

                </el-table>

                <el-pagination
                    style="margin:20px 0"
                    background
                    @current-change="handleCurrentChange2"
                    :current-page="current_page2"
                    :page-size="per_page2"
                    layout="prev, pager, next"
                    :total="total2">
                </el-pagination>
            </el-card>  
        </el-dialog>
    </div>
</template>

<script>
    import option from "../config/option.js"
    import { powerList,url2 } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                total2: 1,
                per_page2: 50,
                current_page2: 1,
                options: [],
                address:'',

                dialogVisible:false,
                dialogVisible2:false,
                dialogVisible3:false,
                dialogVisible4:false,
                dialogVisible5:false,
                dialogVisible6:false,
                shengshu:'',
                money:'',
                time:'',
                mess:'',
                tableData:[],
                tableData2:[],

                time_search:[],
                kucun1:0,
                kucun2:0,
                kucun3:0,
                kucun_buy:0,
                kucun_all_money:0,
                start:'',

                time2:'',
                chayi:'',
                mess2:'',
                kucun_chayi:0,

                now:0,
                now1:0,
                now2:0,
                now3:0,
                now4:0,
                now5:0,
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time_search.push(time1)
            this.time_search.push(time2)

            await this.getUser()
        },
		methods: {
            caoZuoKucun(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2 +'caoZuoKucun', {
                        params:{
                            id:x,
                            id_status:y,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.getKucun()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },
            caoZuoKucun2(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2 +'caoZuoKucun2', {
                        params:{
                            id:x,
                            id_status:y,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.chaYi2()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },
            chaYi() {
                this.dialogVisible5 = true
            },
            buy() {
                this.dialogVisible = true
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getKucun();
            },
            handleCurrentChange2(val) {
                this.current_page2 = val;
                this.chaYi2();
            },
            search1() {
                this.current_page = 1
                this.getKucun()
            },
            search2() {
                this.current_page2 = 1
                this.chaYi2()
            },
            
            async getKucun(flag) {
                this.kucun_buy = 0
                this.kucun_all_money = 0
                var time1 = ''
                var time2 = ''
                if(this.time_search) {
                    time1 = this.time_search[0] + ' 00:00'
                    time2 = this.time_search[1] + ' 23:59'
                }
                await this.axios.get(url2 + 'buyyouSearch', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        address:this.address == '全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                    }
                }).then(res=> {
                    if(!flag) {
                        this.dialogVisible3 = true
                    }
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                    this.kucun_buy = Number(res.data.data2.toFixed(2))
                    this.kucun_all_money = Number(res.data.data3.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },

            async chaYi2(flag) {
                this.kucun_chayi = 0
                var time1 = ''
                var time2 = ''
                if(this.time_search) {
                    time1 = this.time_search[0] + ' 00:00'
                    time2 = this.time_search[1] + ' 23:59'
                }
                await this.axios.get(url2 + 'chayiSearch', {
                    params:{
                        page:this.current_page2,
                        per_page:this.per_page2,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                    }
                }).then(res=> {
                    if(!flag) {
                        this.dialogVisible6 = true
                    }
                    this.tableData2 = res.data.data.data
                    this.total = res.data.data.total
                    this.kucun_chayi = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },
            
            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },

            cySure() {
                if(this.chayi=='') {
                    this.$message.error('请输入差异数');
                    return;
                } else if(this.time2=='') {
                    this.$message.error('请输入时间');
                    return;
                } else {
                    this.time2 = this.formatDate(this.time2)
                    this.axios.get(url2 + 'yhcy', {
                        params:{
                            chayi:this.chayi,
                            time:this.time2,
                            mess:this.mess2,
                            shenpiren:localStorage.getItem('ws_name'),
                            address:this.address,
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.time2=''
                        this.dialogVisible5 = false;
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },

            sure() { 
                if(this.shengshu=='') {
                    this.$message.error('请输入升数');
                    return;
                } else if(this.money=='') {
                    this.$message.error('请输入金额');
                    return;
                } else if(this.time=='') {
                    this.$message.error('请输入时间');
                    return;
                } else {
                    this.time = this.formatDate(this.time)
                    this.axios.get(url2 +'buyYou', {
                        params:{
                            address:this.address,
                            shengshu: this.shengshu,
                            money: this.money,
                            time: this.time,
                            shenpiren:localStorage.getItem('ws_name'),
                            mess:this.mess,
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.time=''
                        this.dialogVisible = false;
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },

            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list  = res.data[0].you.split(',')
                    list.map(item=> {
                        this.options.push(item)
                    })
                    this.address = this.options[0]
                    if(this.address == '全部') {
                        this.options = option.you
                        this.options = this.options.slice(2)
                        this.address = this.options[0]
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            async searchSy(flag) {
                await this.sy1()
                await this.sy2()
                await this.sy3(flag?flag:'')
            },

            async sy1() {
                this.kucun1=0
                var time1 = ''
                var time2 = ''
                if(this.time_search) {
                    time1 = this.time_search[0] + ' 00:00:00'
                    time2 = this.time_search[1] + ' 23:59:59'
                }
                await this.axios.get(url2 + 'youkaSearch', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        chepai:'',
                        name:'',
                        bumen: '',
                        address:this.address =='全部'? '':this.address,
                        gongsi:'',
                        crate_time1:time1,
                        crate_time2:time2,
                        status:1,
                        status2:'',
                        fangshi:'',
                        xz_status:'',
                    }
                }).then(res=> {
                    this.kucun1 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },
            async sy2() {
                this.kucun2=0
                var time1 = ''
                var time2 = ''
                if(this.time_search) {
                    time1 = this.time_search[0] + ' 00:00:00'
                    time2 = this.time_search[1] + ' 23:59:59'
                }
                await this.axios.get(url2 + 'youka2Search', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        name:'',
                        bumen:'',
                        // address: this.address,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                        status:'',
                    }
                }).then(res=> {
                    this.kucun2 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },
            async sy3(flag) {
                this.kucun3=0
                var time1 = ''
                var time2 = ''
                if(this.time_search) {
                    time1 = this.time_search[0] + ' 00:00:00'
                    time2 = this.time_search[1] + ' 23:59:59'
                }
                await this.axios.get(url2 + 'youka3Search', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        name:'',
                        // address: this.address,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                        status:'',
                    }
                }).then(res=> {
                    if(!flag) {
                        this.dialogVisible2 = true
                    }
                    this.kucun3 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },

            async search3() {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await this.getKucun(1)
                await this.chaYi2(1)
                await this.searchSy(1)

                await this.getKucun2()
                await this.chaYi22()
                await this.searchSy2()
                this.loading.close();

                this.now = 0
                this.start = 0
                this.now = this.now1 - this.now2 - this.now3 - this.now4 - this.now5
                this.now = Number(this.now.toFixed(2))
                this.start = this.now + this.kucun_chayi + this.kucun1 + this.kucun2 + this.kucun3 - this.kucun_buy
                this.start = Number(this.start.toFixed(2))
                this.dialogVisible4 = true
            },

            async getKucun2() {
                this.now1 = 0
                var time1 = '2020-01-01 00:00'
                var time2 = ''
                if(this.time_search) {
                    time2 = this.time_search[1] + ' 23:59'
                }
                await this.axios.get(url2 + 'buyyouSearch', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        // address:this.address,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                    }
                }).then(res=> {
                    this.now1 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },

            async chaYi22() {
                this.now2 = 0
                var time1 = '2020-01-01 00:00'
                var time2 = ''
                if(this.time_search) {
                    time2 = this.time_search[1] + ' 23:59'
                }
                await this.axios.get(url2 + 'chayiSearch', {
                    params:{
                        page:this.current_page2,
                        per_page:this.per_page2,
                        // address:this.address,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                    }
                }).then(res=> {
                    this.now2 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },

            async searchSy2() {
                await this.sy4()
                await this.sy5()
                await this.sy6()
            },

            async sy4() {
                this.now3=0
                var time1 = '2020-01-01 00:00'
                var time2 = ''
                if(this.time_search) {
                    time2 = this.time_search[1] + ' 23:59'
                }
                await this.axios.get(url2 + 'youkaSearch', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        chepai:'',
                        name:'',
                        bumen:'',
                        address:this.address =='全部'? '':this.address,
                        gongsi:'',
                        crate_time1:time1,
                        crate_time2:time2,
                        status:1,
                        status2:'',
                        fangshi:'',
                        xz_status:'',
                    }
                }).then(res=> {
                    this.now3 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },
            async sy5() {
                this.now4=0
                var time1 = '2020-01-01 00:00'
                var time2 = ''
                if(this.time_search) {
                    time2 = this.time_search[1] + ' 23:59'
                }
                await this.axios.get(url2 + 'youka2Search', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        name:'',
                        bumen:'',
                        // address: this.address,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                        status:'',
                    }
                }).then(res=> {
                    this.now4 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },
            async sy6() {
                this.now5=0
                var time1 = '2020-01-01 00:00'
                var time2 = ''
                if(this.time_search) {
                    time2 = this.time_search[1] + ' 23:59'
                }
                await this.axios.get(url2 + 'youka3Search', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        name:'',
                        // address: this.address,
                        address:this.address =='全部'? '':this.address,
                        crate_time1:time1,
                        crate_time2:time2,
                        status:'',
                    }
                }).then(res=> {
                    this.now5 = Number(res.data.data2.toFixed(2))
                }).catch(err=> {
                    console.log(err);
                });
            },

        }
    }
</script>

<style scoped="scoped" lang='less'>
    .kucun {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .kucun main {
        margin-bottom: 20px;
    }
</style>

